import DeclineProposal from './DeclineProposal';
export default DeclineProposal;